import React, { useEffect } from 'react'
import OnVisible from 'react-on-visible'
import { Section, Image, LinkWithArrow, Link, CtaArrow } from 'newComponents'
import classNames from 'classnames'
import { getHelp } from '../../utils/thirdPartyUtils'
import arrow from '../../images/icons/arrow-right-turquoise.svg'
import twitterIconImg from '../../images/customers/twitter.svg'
import './styles.scss'

// Main Component
const FeatureColumns = (props) => {
  const { data } = props
  const { primary, items } = data
  const {
    title,
    background,
    content,
    bottom_cta_text: ctaText,
    bottom_cta_url: ctaUrl,
    icons_on_top: iconsOnTop,
    four_column_layout: fourColumnLayout
  } = primary

  // content checks
  const titleHtml = title?.html
  const contentHtml = content?.html
  if (!items) return null
  const backgroundColor = background === 'White' || !background ? 'white' : 'dark-blue'

  // layout variant
  const colAmount = items.length > 3 ? 'two-cols' : 'three-cols'

  return (
    <OnVisible
      className={classNames(`feature-columns ${colAmount} ${backgroundColor}`, {
        'icons-on-top': iconsOnTop,
        'four-columns-layout': fourColumnLayout
      })}
    >
      <Section>
        {titleHtml && <div className="feature-block-title" dangerouslySetInnerHTML={{ __html: titleHtml }} />}
        {contentHtml && <div className="feature-block-content" dangerouslySetInnerHTML={{ __html: contentHtml }} />}
        <div className="feature-columns-features-container">
          <div className="feature-columns-feautres">
            {items.map((item) => (
              <FeatureItem key={item?.feature_content?.html} item={item} />
            ))}
          </div>
          {ctaUrl.url && (
            <div className="cta-link-wrapper">
              <Link to={ctaUrl.url}>
                {ctaText.text} <CtaArrow />
              </Link>
            </div>
          )}
        </div>
      </Section>
    </OnVisible>
  )
}

// Feature Item
const FeatureItem = ({ item }) => {
  const {
    feature_content: featureContent,
    icon,
    feature_title: featureTitle,
    cta_link: ctaLink,
    cta_text: ctaText,
    is_card_style: isCardStyle,
    link_to_tweet: linkToTweet
  } = item

  const featureContentHtml = featureContent?.html
  const fTitleHtml = featureTitle?.html
  const hasIcon = icon?.url || icon?.localFile
  const hasCta = ctaLink?.url && ctaText?.text
  const hasCtANotCard = hasCta && !isCardStyle

  return (
    <FeatureItemContainer item={item}>
      {hasIcon && <Image className="feature-columns-feauture-image" image={icon} />}
      <div className="feature-columns-feature-text">
        {fTitleHtml && (
          <div className="feature-columns-feature-title" dangerouslySetInnerHTML={{ __html: fTitleHtml }} />
        )}
        {featureContentHtml && (
          <div className="feature-columns-feature-content" dangerouslySetInnerHTML={{ __html: featureContentHtml }} />
        )}
        {hasCtANotCard && (
          <LinkWithArrow to={ctaLink.url} className="feature-columns-cta">
            {ctaText.text}
          </LinkWithArrow>
        )}
        {isCardStyle && (
          <div className={`feature-columns-cta ${linkToTweet ? 'with-twitter-icon' : 'inactive'} `}>
            {linkToTweet && (
              <span className="twitter-icon">
                <Image className="testimony-socials-icon" image={twitterIconImg} />
              </span>
            )}
            <span className="feature-columns-cta-text">
              {ctaText.text}
              <CtaArrow />
            </span>
          </div>
        )}
      </div>
    </FeatureItemContainer>
  )
}

// Feature Item Container
const FeatureItemContainer = ({ item, children }) => {
  const { cta_link: ctaLink, feature_title: featureTitle, is_card_style: isCardStyle } = item

  if (isCardStyle) {
    return (
      <a onClick={triggerIntercomWhenEmpty} className="feature-columns-card" href={ctaLink.url}>
        <div className="feature-columns-feature" key={featureTitle.text}>
          {children}
        </div>
      </a>
    )
  }

  return (
    <div className="feature-columns-feature" key={featureTitle.text}>
      {children}
    </div>
  )
}

const triggerIntercomWhenEmpty = (e) => {
  e.preventDefault()
  e.persist()

  if (e.currentTarget.href === window.location.href) {
    getHelp(e)
  } else {
    window.location = e.currentTarget.href
  }
}

export default FeatureColumns
